import { useParams } from "react-router-dom";
import { Breadcrumbs } from "components/breadcrumbs";
import { useGetDetail } from "routes/customerAccount/hooks/useGetDetail";
import useQueryParams from "routes/customerAccount/hooks/useQueryParams";
import { DetailCustomerAccountType } from "routes/customerAccount/types";
import { FullScreenLoading } from "components/fullScreenLoading";
import CustomerAccountForm from "routes/customerAccount/components/Form";

const CustomerAccountDetailPage = () => {
  const PAGE_SIZE = 10;

  const { id } = useParams();
  const { searchParams, paramsObject, setQueryParams } = useQueryParams();

  const favoriteEventsPage = searchParams.get("favorite_events_page")
    ? Number(searchParams.get("favorite_events_page"))
    : 1;

  const { data, loading, params, setParams, fetchData } = useGetDetail(
    id ?? "",
    {
      page: favoriteEventsPage,
      limit: PAGE_SIZE,
    }
  );

  const handleChangePage = (page: number) => {
    // Update URL search params
    setQueryParams({
      favorite_events_page: page.toString(),
    });

    setParams({ ...params, page: page }); // Update API params
  };

  return (
    <section className="wrapper">
      {loading && <FullScreenLoading />}

      <Breadcrumbs customPageLabel="Detail Customer Account" />

      {!loading && !data && (
        <div className="w-full min-h-[calc(100%-72px)] bg-[#f6f5fe] flex flex-col items-center py-[50px]">
          <div className="text-brand-500 text-center">
            <div className="text-36 font-700 mb-[16px]">
              Customer Account not found
            </div>
            <div className="text-20 mb-[8px]">
              The customer account does not exist
            </div>
            <div className="text-20">
              Please contact your Administrator for assistance
            </div>
          </div>
        </div>
      )}

      {!loading && data && (
        <CustomerAccountForm
          data={data}
          mode="detail"
          handleChangePage={handleChangePage}
        />
      )}
    </section>
  );
};

export default CustomerAccountDetailPage;
